"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var serializr_1 = require("serializr");
var social_groups_api_1 = require("@wix/social-groups-api");
var store_1 = require("./store");
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var baseUrl_1 = require("@wix/social-groups-common/dist/src/baseUrl");
var Controller_1 = require("../Controller");
var PubSubEventTypes_1 = require("../pubSub/PubSubEventTypes");
var utils_1 = require("../members/utils");
var FeedController = /** @class */ (function (_super) {
    tslib_1.__extends(FeedController, _super);
    function FeedController(controllerConfig, groupId) {
        var _this = _super.call(this, controllerConfig, groupId) || this;
        _this.updateFeedStore = function (_a) {
            var instance = _a.instance;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var groupId;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getGroupId()];
                        case 1:
                            groupId = _b.sent();
                            this.setFeedStore(instance, groupId);
                            //TODO: 💩 repository tightly coupled with feed items, refactor?
                            this.feedStore.updateFeedItemsRepository();
                            this.updateContextToken();
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.addReaction = function (feedItemId, reaction) {
            var userReaction = _this.getUserReaction(reaction);
            _this.feedStore.addReaction(feedItemId, userReaction);
        };
        _this.removeReaction = function (feedItemId, reactionCode) {
            var userReaction = _this.getUserReaction({ reactionCode: reactionCode });
            _this.feedStore.removeReaction(feedItemId, userReaction);
        };
        _this.createFeedItem = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setProps({ isFeedItemCreating: true });
                            return [4 /*yield*/, this.feedStore.create.bind(this.feedStore).apply(void 0, tslib_1.__spread(args))];
                        case 1:
                            _a.sent();
                            this.setProps({ isFeedItemCreating: false });
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.pageReady = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.bindActions();
                mobx_1.autorun(function () {
                    var store = serializr_1.serialize(_this.feedStore);
                    _this.setProps({
                        feedLoading: store.loading,
                        cursor: store.cursor,
                        feedItems: store.feedItems,
                    });
                });
                return [2 /*return*/];
            });
        }); };
        _this.onUserLogin(_this.updateFeedStore);
        _this.setSubscriptions();
        return _this;
    }
    FeedController.prototype.setFeedStore = function (instance, groupId) {
        var location = this.getLocation();
        var baseUrl = baseUrl_1.getSocialApiBaseUrl(location.baseUrl);
        this.feedRepository = new social_groups_api_1.SocialContentService(instance, groupId, new social_groups_api_1.ContextTokenService(instance, this.getApiBaseUrl()), baseUrl);
        if (this.feedStore) {
            this.feedStore.repository = this.feedRepository;
        }
        else {
            this.feedStore = new store_1.FeedStore(this.feedRepository);
        }
    };
    FeedController.prototype.setFeed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groupId, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getGroupId()];
                    case 1:
                        groupId = _a.sent();
                        this.setFeedStore(this.getSiteToken(), groupId);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        loggers_1.ConsoleLogger.log('FeedController.setFeed', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FeedController.prototype.bindActions = function () {
        this.setProps({
            fetchMore: this.feedStore.fetchMore.bind(this.feedStore),
            deleteFeedItem: this.feedStore.delete.bind(this.feedStore),
            createFeedItem: this.createFeedItem,
            updateFeedItem: this.feedStore.update.bind(this.feedStore),
            reactFeedItem: this.addReaction,
            unreactFeedItem: this.removeReaction,
            commentFeedItem: this.feedStore.comment.bind(this.feedStore),
            pinFeedItem: this.feedStore.pin.bind(this.feedStore),
            unpinFeedItem: this.feedStore.unpin.bind(this.feedStore),
            followFeedItem: this.feedStore.follow.bind(this.feedStore),
            unfollowFeedItem: this.feedStore.unfollow.bind(this.feedStore),
        });
    };
    FeedController.prototype.getUserReaction = function (reaction) {
        var userReaction = {
            reaction: reaction,
            userId: this.getCurrentUser().id,
        };
        return userReaction;
    };
    FeedController.prototype.setProps = function (props) {
        return this.controllerConfig.setProps(props);
    };
    FeedController.prototype.updateContextToken = function () {
        var _this = this;
        // tslint:disable-next-line: no-floating-promises
        this.feedRepository.feed
            .getContextToken()
            .then(function (contextToken) { return _this.setProps({ contextToken: contextToken }); });
    };
    FeedController.prototype.getInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var feedItemIdFromUrl, e_2, store, cursor, loading, feedItems, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.setFeed()];
                    case 1:
                        _b.sent();
                        feedItemIdFromUrl = this.getFeedItemIdFromUrl();
                        if (!feedItemIdFromUrl) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.feedStore.fetchById(feedItemIdFromUrl)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.feedStore.fetch()];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        this.publishAuthorsIds();
                        return [3 /*break*/, 7];
                    case 6:
                        e_2 = _b.sent();
                        loggers_1.ConsoleLogger.log('FeedController.getInitialProps: FAILED in fetch feed', e_2);
                        return [3 /*break*/, 7];
                    case 7:
                        store = serializr_1.serialize(this.feedStore);
                        cursor = store.cursor, loading = store.loading, feedItems = store.feedItems;
                        _a = {
                            feedLoading: loading,
                            cursor: cursor,
                            feedItems: feedItems
                        };
                        return [4 /*yield*/, this.feedRepository.feed.getContextToken()];
                    case 8: return [2 /*return*/, (_a.contextToken = _b.sent(),
                            _a)];
                }
            });
        });
    };
    FeedController.prototype.setSubscriptions = function () {
        var _this = this;
        try {
            this.controllerConfig.platformAPIs.pubSub.subscribe(PubSubEventTypes_1.PubSubEventTypes.UPDATE_CONTEXT_TOKENS_EVENT, function (eventData) {
                return _this.updateFeedStore({ instance: _this.getSiteToken() });
            }, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    FeedController.prototype.publishAuthorsIds = function () {
        var ids = this.getFeedAuthorsIds();
        try {
            this.controllerConfig.platformAPIs.pubSub.publish(PubSubEventTypes_1.PubSubEventTypes.FEED_AUTHORS_IDS, ids, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    FeedController.prototype.getFeedAuthorsIds = function () {
        try {
            var idsFromFeed = this.feedStore.feedItems.map(function (post) { return post.createdBy; });
            return utils_1.uniqueStrings(idsFromFeed);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
        return [];
    };
    return FeedController;
}(Controller_1.Controller));
exports.FeedController = FeedController;
//# sourceMappingURL=controller.js.map